export default "__VITE_PUBLIC_ASSET__855d65a1__"